import React from "react";
import { connect } from "react-redux";
import { getCurrentDealer } from "../modules/dealers";
import Loading from "../components/Loading";
import ProductDetail from "../components/ProductDetail";
import useFetchProduct from "../components/useFetchProduct";

const container = connect(state => ({
  dealer: getCurrentDealer(state)
}));

const ProductShow = container(
  ({
    dealer,
    match: {
      params: { productId, dealer_id }
    }
  }) => {
    const dealerId = dealer_id || dealer.id;
    const { loading, product } = useFetchProduct({ productId, dealerId });
    if (loading) {
      return <Loading label="Loading product" />;
    }
    if (product) {
      return <ProductDetail product={product} />;
    }
    return null;
  }
);

ProductShow.displayName = "ProductShow";

export default ProductShow;
